import validate from "/codebuild/output/src1392998611/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/codebuild/output/src1392998611/src/packages/frontend/middleware/auth.global.ts";
import rollout_45identifier_45global from "/codebuild/output/src1392998611/src/packages/frontend/middleware/rollout-identifier.global.ts";
import manifest_45route_45rule from "/codebuild/output/src1392998611/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  rollout_45identifier_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}